<template>
    <div class="contentPopup">
        <van-popup v-model="isPromoteRuleShow"
                   :closeable="false"
                   :round="true"
                   :close-on-click-overlay="false"
                   overlay
                   class="promotePopup">
            <div class="block">
                <div class="title-popup">活动规则</div>
                <div class="content">
                    <h2>一、佣金加码</h2><br />
                    <h3>1、活动说明</h3>
                    活动时间：<br />
                    活动分为5个阶段，每个阶段期间大使推广指定补贴品达到规定订单数量门槛，可获得相应现金补贴。本活动只对报名大使进行结算，如您决定参与本次推广活动，请先点击报名。<br /><br />
                    <h3>1、 统计范围</h3><br />
                    指定参与活动品为芒果TV会员年卡、芒果超级乐享卡、芒果TV全屏会员连续包年卡，芒果TV会员连续包年卡赠喜马拉雅年卡，活动仅计算活动期内有效推广指定活动品类的一级订单（即大使推广的一级用户付款成功的订单，以下简称“个人订单”，退单/无效订单不计入订单量）。<br /><br />
                    <h3>2、 补贴规则</h3><br />
                    大使获得的现金补贴＝个人订单*补贴金，按结束时单量所在档位补贴，每阶段仅可以领取一次，不叠加领取；不同活动时段奖金可叠加领取。具体标准如下：<br /><br />
                    ① 2023年4月25日10:00-2023年4月30日23:59（共6天）<br />
                    个人订单达到360单及以上，每单奖励5元，赠送一张芒果TV 会员3天卡;<br />
                    个人订单达到1080单及以上，每单奖励7元，赠送一张芒果TV 会员周卡;<br />
                    个人订单达到2100单及以上，每单奖励10元，赠送一张芒果TV会员周卡;<br />
                    ② 2022年5月4日00:00-2023年5月7日23:59（共4天）<br />
                    个人订单达到240单及以上，每单奖励3元；每2单赠送一张芒果TV 会员3天卡；<br />
                    个人订单达到800单及以上，每单奖励4.5元；每6单赠送一张芒果TV会员月天卡；<br />
                    个人订单达到1400单及以上，每单奖励7元；每3单赠送一张芒果TV会员月天卡；<br />
                    ③ 2023年5月11日00:00-2023年5月14日23:59（共4天）<br />
                    个人订单达到320单及以上，每单奖励2.5元，并获得芒果TV 会员1天卡50张；<br />
                    个人订单达到800单及以上，每单奖励4元；并获得芒果TV1 会员1天卡100张；<br />
                    个人订单达到1440单及以上，每单奖励7元；并获得芒果TV 会员3天卡300张和芒果TV 会员1天卡200张；<br />
                    ④ 2023年5月18日00:00-2023年5月21日23:59（共4天）<br />
                    个人订单达到400单及以上，每单奖励1.5元，并获得芒果TV 会员1天卡20张；<br />
                    个人订单达到800单及以上，每单奖励3元，并获得芒果TV 会员1天卡50张；<br />
                    个人订单达到1440单及以上，每单奖励5元，并获得芒果TV 会员3天卡100张和芒果TV 会员1天卡100张；<br />
                    ⑤2023年5月24日00:00-2023年5月30日23:59（共7天）<br />
                    个人订单达到560单及以上，每单奖励1.5元;<br />
                    个人订单达到1120单及以上，每单奖励3元;<br />
                    个人订单达到1960单及以上，每单奖励5.5元；<br /><br />
                    <h3>3、 补贴发放</h3><br />
                    活动结束后5个工作日内进行结果公示（1天），公示结束后获得的现金将以佣金形式发放至对应大使的M-CLUB账户，请至【我的】奖励明细查看（奖金均为含税金额，奖金发放时将依据法律要求扣除相应税费）；获得的芒果会员卡补贴以卡密形式发放，请联系社群工作人员-程程领取。<br /><br />
                    <h3>4、 活动卡特别说明：</h3><br />
                    活动奖励的所有会员卡均有使用期限限制，请以官方规定日期为准，严格依据官方要求使用，严禁公开销售、低价售卖等，如大使违反相关要求，芒果TV有权停用和追回活动会员卡权益，根据大使违规情况，对大使采取账号封禁、佣金冻结等不同程度的处罚措施。<br /><br />
                    <h2>二、组队冲榜</h2><br />
                    <h3>1、活动说明</h3><br />
                    活动期间团队订单排名前6名、且达到对应订单门槛的情况下，即可获得对应奖励。<br /><br />
                    <h3>1、 收入统计时间</h3><br />
                    活动共分成两个阶段，阶段一：2023年4月25日-2023年5月7日，（13天），阶段二：2023年5月11日-2023年5月21日（11天），两个阶段活动奖励可叠加领取。<br /><br />
                    <h3>2、 统计范围</h3><br />
                    指定参与活动品为芒果TV会员年卡、芒果超级乐享卡、芒果TV全屏会员连续包年卡，芒果TV会员连续包年卡赠喜马拉雅年卡，活动仅计算活动期内有效推广指定活动品类付款成功的一级订单，退单/无效订单不计入订单量。<br /><br />
                    <h3>4、参与流程</h3><br />
                    ①加入M-CLUB成为推广大使，在活动页面报名成为队长发起组队，队长邀请1人即可成队，最多邀请2人，即1个团队最多不超过3人，且组队成功后队长和队员皆不可退出； <br />
                    ②活动期间top6排名，仅统计已报名组队大使的订单，若未报名且未被邀请进入团队，则不计入订单排行榜，<br />
                    ③组队成功后，若团队订单达标，则团队内每人所得奖金=个人订单/团队总销量*团队所得奖金。<br /><br />
                    <h3>5、具体奖金及领取条件：</h3><br />
                    阶段一：2023年4月25日00:00-2023年5月7日23:59（13天）<br />
                    订单排名第一名至第二名，且个人订单不低于2880单，奖金6666元；<br />
                    订单排名第三名，且个人订单不低于2250单，奖金3333元；<br />
                    订单排名第四名至第六名，且个人订单不低于1440单，奖金2000元；<br />
                    阶段二：2023年5月11日00:00-2023年5月21日23:59（11天）<br />
                    订单排名第一名至第二名，且个人订单不低于2880单，奖金4000元；<br />
                    订单排名第三名，且个人订单不低于2250单，奖金2000元；<br />
                    订单排名第四名至第六名，且个人订单不低于1440单，奖金999元；<br />
                    <h3>6、奖金发放规则</h3><br />
                    1）奖金到账：活动结束后5个工作日内进行结果公示（1天），公示结束后按照最终排名，以佣金形式将排行榜对应奖金发放至对应大使的M-CLUB账户，公示结束后获得的现金以佣金形式发放至对应大使的M-CLUB账户，请至【我的】奖励明细查看（奖金均为含税金额，奖金发放时将依据法律要求扣除相应税费）；获得的芒果卡补贴以卡密形式发放，请联系社群程程领取。<br /><br />
                    2）若大使存在收入相同的情况，则以最后一笔订单的时间为准，订单生成时间较前的大使，则排名在前，单个用户不可重复领奖。<br /><br />
                    3）根据最终个人收入所满足的领取条件，自动匹配符合奖金，以实际收入的高低进行排名；<br /><br />
                    4）如无人满足发放条件，则当前排名奖金空缺。例如：团队实际排名第1，团队订单2800单，不符合达标条件，则第一名奖金空缺，大使A可得第二名3333元奖励。<br /><br />
                    5）每个排名对应的奖金，仅可领取1次，按照最终收入顺延。<br /><br />
                    7、活动卡特别说明：活动奖励的所有会员卡均有使用期限限制，请以官方规定日期为准，严格依据官方要求使用，严禁公开销售、低价售卖等，如大使违反相关要求，芒果TV有权停用和追回活动会员卡权益，根据大使违规情况，对大使采取账号封禁、佣金冻结等不同程度的处罚措施。<br /><br />
                    <h2>三、活动参与条件</h2><br />
                    所有报名成功的芒果M-CLUB注册用户（M-CLUB账号封停用户除外）均可参与本次活动。<br /><br />
                    <h2>四、其他说明</h2><br />
                    1、活动期间，如用户存在违反法律、法规或违反包括但不限于芒果TV、芒果M-CLUB及其他活动合作平台方规则，包括但不限于作弊、⽹络攻击、恶意套现、虚假交易采用不正当技术手段获得商品、奖金等行为，芒果M-CLUB将有权取消用户的成绩，撤销违规交易，收回商品或奖金权益。<br /><br />
                    2、活动期间如出现不可抗力或情势变更的情况（包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整、活动遭受严重网络攻击或因系统故障需要暂停举办的），M-CLUB可依相关法律法规的规定主张免责。<br /><br />
                    3、若您对本次活动规则有任何疑问，芒果M-CLUB将在法律允许的范围内对本活动规则给予必要的说明和解释。相关销售数据以芒果M-CLUB后台数据为准。如有疑问，欢迎随时与我们的客服联系，客服入口，关注【芒果推广大使】公众号-点击【我要赚钱】-【我的】-【联系客服】。<br /><br />
                    4、⽤同⼀登录账号、同⼀⼿机号、同⼀终端设备号、同⼀收货⼿机号和地址、同⼀⽀付账户同⼀IP或其它合理显⽰为同⼀⽤户的情形均视为同⼀⽤户。⼀旦发现有违规操作⽤户，芒果M-CLUB取消活动参与资格，取消权益发放。<br /><br />
                    5、本活动涉及的一切时间均以东八区区时（即北京时间）为准。<br /><br />
                    6、本活动与Apple Inc.苹果公司无关。<br /><br />
                    <h2>五、未成年人特殊约定</h2><br />
                    1、若您为未成年人，应在监护人监护、指导下阅读本活动规则。<br />
                    2、监护人应指导未成年人上网应该注意的安全问题，防患于未然。若监护人同意未成年人使用本活动消费项目，必须以监护人名义申请消费，并对未成年人使用消费项目进行正确引导、监督。未成年人使用消费项目，以及行使和履行本协议项下的权利和义务即视为已获得了监护人的认可。<br />
                    3、芒果M-CLUB提醒未成年人在使用网络虚拟服务时，要善于网上学习，认清网络世界与现实世界的区别，避免沉迷于网络，影响日常的学习生活。
                </div>
            </div>
            <div class="iconClose"
                 @click="handleClose">
                <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/da95a2d54baa45149f27cfa45619775b.png"
                     alt="">
            </div>
        </van-popup>
    </div>
</template>
<script>
export default {
    props: {
        isPromoteRuleShow: {
            type: Boolean
        }
    },
    data() {
        return {}
    },
    created() {},
    mounted() {},
    methods: {
        handleClose() {
            // this.isPromoteRuleShow = false
            this.$emit('closeRulePopup')
        }
    }
}
</script>
<style lang="less" scoped>
.promotePopup {
    background-color: transparent;
    height: 11.18rem;

    .block {
        position: relative;
        padding-top: 0.001rem;
        width: 8.4rem;
        height: 9.4rem;
        background: #ffffff;
        border-radius: 0.21rem;
        box-sizing: border-box;

        .title-popup {
            margin: 0.4rem 0 0;
            text-align: center;
            font-size: 0.5rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 700;
            color: #333333;
            line-height: 0.64rem;
        }

        .content::-webkit-scrollbar {
            display: none;
        }

        .content {
            margin: 0.27rem 0.32rem 1.24rem;
            padding: 0.27rem;
            height: 6.85rem;
            background: #f9f6f6;
            border-radius: 0.19rem;
            box-sizing: border-box;
            overflow-x: hidden;
            overflow-y: scroll;

            > h2 {
                font-size: 0.4rem;
            }
        }
    }

    .iconClose {
        position: absolute;
        top: 9.8rem;
        left: 50%;
        width: 1.28rem;
        height: 1.28rem;
        margin-left: -0.64rem;

        & > img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>